import { ArrowLeft, Menu } from "lucide-react";
import type { CSSProperties, ReactNode } from "react";

type Props = {
  onBack: () => void;
  title?: string;
  icon?: ReactNode;
  accentColor?: string;
};

export default function TaskOptionSheetHeader({
  onBack,
  title = "Options",
  icon,
  accentColor,
}: Props) {
  return (
    <header className="ui-options-header sticky top-0 z-20 flex items-center gap-3 bg-background px-1 pb-4 pt-4">
      <button
        type="button"
        onClick={onBack}
        className="ui-options-header__back inline-flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent/40"
        aria-label={`Back from ${title}`}
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      </button>
      <span
        className="ui-options-header__icon"
        style={
          accentColor ? ({ color: accentColor } as CSSProperties) : undefined
        }
        aria-hidden="true"
      >
        {icon ?? <Menu className="h-5 w-5" />}
      </span>
      <span className="ui-options-header__title font-display text-2xl tracking-tight text-foreground">
        {title}
      </span>
    </header>
  );
}
